<form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
<div mat-dialog-title>
    <h1>Add Services</h1>
    <button mat-button mat-dialog-close><mat-icon aria-hidden="false"
            aria-label="Example home icon">close</mat-icon></button>
</div>

<div mat-dialog-content>
        <div class="container">
            <div class="row">

                <div class="col-6">
                    <mat-form-field class="full-width-field">
                        <mat-label>Service Type</mat-label>
                        <mat-select>
                            <mat-option *ngFor="let service of service_types"
                                [value]="service.id">{{ service.value }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-6">
                    <app-duration-dropdown></app-duration-dropdown>
                </div>

                <!-- <div class="col-6">
                    <app-instructor-list-dropdown [InstructorList]=data.InstructorList></app-instructor-list-dropdown>
                </div> -->

                <div class="col-6">
                    <app-duration-dropdown></app-duration-dropdown>
                </div>

                <div class="col-6">
                    <mat-form-field class="full-width-field">
                        <mat-label>Date and Time</mat-label>
                        <input name="date" matInput [matDatepicker]="picker">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="col-12">
                    <app-standing-appointment></app-standing-appointment>
                </div>

                <div class="col-12 mt-1">
                    <!-- <app-personal-information ></app-personal-information> -->
                </div>

                <div class="col-12">
                    <mat-form-field class="full-width-field">
                        <mat-label>Notes</mat-label>
                        <textarea ngModel name="field_notes" matInput placeholder=""></textarea>
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field class="full-width-field">
                        <mat-label>Status</mat-label>
                        <mat-select
                            ngModel
                            name="field_status">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let status of statusList" [value]="status.id">{{ status.value }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                
                <button type="submit" mat-raised-button color="primary">Save and Add Lesson</button>

            </div>

        </div>
        
    </div>
</form>